module.exports = __webpack_public_path__ + "static/taiga-688f0cc711c5845f982b9a21a8836f54.svg";